<template>
  <div class="container_box">
    <Tabs v-model="pageParams.orderTabType" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in orderTabTypeList" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="oneItemCol" v-if="merchantConfigurationFactory">
            <FormItem :label="$t('key1004503')">
              <local-tabButton :tabButtonList="orderTypeList" @selectStatus="orderTypeBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '95px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
            v-if="['0', '1'].includes(pageParams.orderTabType)">
            <FormItem :label="$t('key1004602')" prop="packageOrderStatusList">
              <Select v-model="pageParams.packageOrderStatusList" multiple :placeholder="$t('key1004603')">
                <Option v-for="item in orderStatusList" :key="item.value"
                  :value="item.value">{{ item.title }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
            v-if="['0', '1', '2', '4', '5'].includes(pageParams.orderTabType)">
            <FormItem :label="$t('key1004555')" prop="outPackageOrderStatusList">
              <Select v-model="pageParams.outPackageOrderStatusList" multiple :placeholder="$t('key1004569')">
                <Option v-for="item in deliveryOrderStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownDateTime
              :transfer="false"
              ref="dropDownDateTime"
              :dropDownTimeList="dropDownTimeList"
              :defaultSelectValue="defaultSelectTimeValue"
              @changeInput="changeTimeInput"
              @selectTime="selectTime"
              @resetTime="resetTime">
            </dropDownDateTime>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
            v-if="['0', '4'].includes(pageParams.orderTabType)">
            <FormItem :label="$t('key1004604')" prop="settlementStatus">
              <Select v-model="pageParams.settlementStatus" multiple :placeholder="$t('key1004605')">
                <Option v-for="item in settlementStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001227')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable>
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="pageParams.orderType === 2">
            <FormItem :label="$t('key1001074')" prop="factoryOrderStatusList">
              <Select v-model="pageParams.factoryOrderStatusList" multiple>
                <Option v-for="item in factoryOrderStatusData" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="pageParams.orderType === 2">
            <FormItem :label="$t('key1006904')" prop="factoryName">
              <Input :placeholder="$t('key1006905')" v-model.trim="pageParams.factoryName"></Input>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box flex align-items-center justify-content-between">
      <div class="flex align-items-center">
        <!--批量发货-->
        <Button class="mr15" @click="bulkShipmentBtn('all')"
          v-if="['1'].includes(pageParams.orderTabType) && endJourneyTalg && getPermission('packageInfo_shipmentDeliveryOrder')">
          {{ $t('key1006863') }}
        </Button>
        <!--导出订单-->
        <Dropdown transfer @on-click="changeExportBtn" class="mr15"
          v-if="getPermission('packageInfo_exportPackageInfoOrder')">
          <Button>
            <span>{{ $t('key1004572') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <!--标记缺货-->
        <Button
          class="mr15"
          v-if="['1'].includes(pageParams.orderTabType) && getPermission('packageInfo_markOutStock')"
          @click="markOutStockBtn('all',null, 1)">{{ $t('key1000526') }}
        </Button>
        <!--标记到货-->
        <Button
          class="mr15"
          v-if="['1'].includes(pageParams.orderTabType) && getPermission('packageInfo_markOutStock')"
          @click="batchMarkingBtn('all')">{{ $t('key1004587') }}
        </Button>
        <!--打印配货清单-->
        <Button
          class="mr15"
          v-if="['1'].includes(pageParams.orderTabType) && endJourneyTalg && getPermission('packageInfo_printPrepareGoods')"
          @click="printDistributionBtn">{{ $t('key1005337') }}
        </Button>
        <!--打印YMS条码-->
        <Dropdown v-if="['1'].includes(pageParams.orderTabType) && endJourneyTalg && batchButtonPermissions(printBarcodeList)"
          transfer @on-click="printBarcodeBtn" class="mr15">
          <Button>
            <span>{{ $t('key1000320') + configCharacters(false) + $t('key1001136') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem v-for="item in printBarcodeList" :name="item.name" v-if="getPermission(item.permissionKey)">
              {{ item.title }}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <!--批量接单-->
        <Button
          class="mr15"
          v-if="['6'].includes(pageParams.orderTabType) && endJourneyTalg && getPermission('packageInfo_receivingOrders')"
          @click="takingOrdersBtn('all', 1)">{{ $t('key1006268') }}
        </Button>
      </div>
      <div class="flex align-items-center">
        <!--自定义列-->
        <Button @click="$refs['customColumns'].initCustomColumnsData()">{{ $t('key1000977') }}</Button>
      </div>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tableDom"
        :highlight-row="false"
        :loading="tableLoading"
        border
        max-height="530"
        :columns="tableColumns"
        :data="tableData"
        :span-method="handleSpan"
        @on-selection-change="tableChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1004572')"
      paramKeyColums="supplierPackageInfoOrderExportColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--配货清单格式弹窗-->
    <distributionListFormatModal ref="distributionListFormat"
      @updateSelect="updateSelect"></distributionListFormatModal>
    <!--日志弹窗-->
    <dailyRecordModal ref="dailyRecord"></dailyRecordModal>
    <!--扫描换单-->
    <scanOrderChangeModal ref="scanOrderChange"></scanOrderChangeModal>
    <!--打印箱唛弹窗-->
    <printCaseMarkModal
      ref="printTalg"
      :apiUrl="apiUrl"
      :printUpdate="true"
      service="yms-supplier-service"
      typeTalg="packingManage"
      @printUpdateData="search('update')">
    </printCaseMarkModal>
    <!--自定义列组件-->
    <customColumnsDrawer
      ref="customColumns"
      customColumnsKey="supplierOrderListColumns"
      :originalColumns="originalColumnsData"
      :defaultSelectKeyList="defaultSelectKeyList"
      @customColumnsData="customColumnsData">
    </customColumnsDrawer>
    <!--标记缺货弹窗-->
    <overtimeOrderProcessingModal ref="overtimeOrderProcess" @updateData="pageParamsStatus = true"></overtimeOrderProcessingModal>
    <!--标记发货弹窗-->
    <markShipmentModal ref="markShipment" @updateData="pageParamsStatus = true"></markShipmentModal>
    <!--查看定制内容弹窗-->
    <viewCustomizedInfoModal ref="viewCustomizedInfo"></viewCustomizedInfoModal>
    <!--打印合规标签弹窗-->
    <printComplianceLabelsModal ref="printComplianceLabels"></printComplianceLabelsModal>
    <!--打印预览YMS面单弹窗-->
    <printPreviewWaybillModal
      :printPreviewWaybillTitle="printPreviewWaybillTitle"
      :batchPrinting="true"
      :editablePrint="false"
      ref="printPreviewWaybill"
      @updatePrint="updatePrint"
      printType="supplier_batchPrintingBarcodes"
      :printUrl="printUrl">
    </printPreviewWaybillModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {
  pageJump, amountHandel, setConfigCharacters, getAllWarehouseData, getWarehouseName, commonLocalStorage, setLinkPath,
  getAllCountrysData, getDataSetBatchList, getEnumList
} from "@/utils/common";
import dropDownFilter from "@/components/common/dropDownFilter.vue";
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import distributionListFormatModal from "@/views/supplier/components/supplierOrder/distributionListFormatModal.vue";
import dailyRecordModal from "@/views/supplier/components/supplierOrder/dailyRecordModal.vue";
import scanOrderChangeModal from "@/views/supplier/components/supplierOrder/scanOrderChangeModal.vue";
import printCaseMarkModal from "@/components/common/printCaseMarkModal.vue";
import dropDownDateTime from "@/components/common/dropDownDateTime";
import customColumnsDrawer from "@/components/common/customColumnsDrawer";
import overtimeOrderProcessingModal from "@/components/common/overtimeOrderProcessingModal";
import markShipmentModal from "@/views/supplier/components/supplierOrder/markShipmentModal.vue";
import viewCustomizedInfoModal from "@/components/common/viewCustomizedInfoModal.vue";
import printComplianceLabelsModal from "@/components/common/printComplianceLabelsModal.vue";
import printPreviewWaybillModal from "@/components/common/printPreviewWaybillModal.vue";

export default {
  name: 'directDeliveryOrderList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      total: 0,
      pageParamsStatus: false,
      pageParams: {
        orderTabType: '1', // 0:全部 1:待发货 2:已发货 4:已完成 5:已取消
        createdEndTime: null, // 下单结束时间
        createdStartTime: null, // 下单开始时间
        shipedStartTime: null, // 发货开始时间
        shipedEndTime: null, // 发货结束时间
        outPackageOrderStatusList: [], // 出库单状态
        packageCodes: '', // 订单号
        packageOrderStatusList: [], // 订单状态
        outboundTypes: [1, 5], // 出库类型(1:销售出库 2:自有仓备货 3:三方仓备货 4:多发补单 5:分销商备货)
        skus: '', // 供应商sku
        ymsSkus: '', // 云卖sku
        settlementStatus: [], // 结算状态
        ymsWarehouseId: null, // 目的仓库
        orderType: 'null', // 订单类型
        factoryOrderStatusList: [], // 工厂订单状态
        factoryName: '', // 工厂名称
        isSupplierSupportDirectDelivery: 1,
        pageNum: 1,
        pageSize: 15,
      },
      tableData: [],
      tableColumns: [],
      originalColumns: [
        {
          type: 'selection',
          width: 60,
          /* fixed: 'left',*/
          className: 'selection_styles_box',
          key: 'idx',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522'),
          key: 'packageCode',
          align: 'left',
          className: 'set_table_td',
          minWidth: 170
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006877'),
          key: 'receiptInfo',
          minWidth: 330,
          align: 'left',
          className: 'set_table_td',
          render(h, params) {
            let {buyerName, buyerMobile, buyerPhone, countryCodeName, buyerState, buyerCity, buyerAddress1, buyerPostalCode} = params.row;
            let list = [
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006420') + buyerName),
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003100') + (buyerMobile || '-')),
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001175') + (buyerPhone || '-')),
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006878') + countryCodeName + '\u2002\u2002' + buyerState + '\u2002\u2002' + buyerCity),
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001168') + buyerAddress1),
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001170') + buyerPostalCode),
            ];
            return h('div', list)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917'),
          key: 'orderStatus',
          align: 'left',
          className: 'set_table_td',
          minWidth: 140,
          render(h, params) {
            let text = '-';
            let orderStatus = params.row.orderStatus;
            let payStatus = params.row.payStatus;
            let waitingAgainSendJson = params.row.waitingAgainSendJson;
            v.orderStatusData.map((item) => {
              if (item.value === orderStatus) {
                if (orderStatus === 1 && payStatus === 1) {
                  text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001800');
                } else {
                  text = item.title;
                }
              }
            })
            // 缺货
            if (orderStatus === 7) {
              let abnormalStatus = params.row.abnormalStatus; // 异常状态 1.正常 2.缺货
              if (abnormalStatus === 2) {
                let outOfStockQuantity = params.row.outOfStockQuantity;
                let outOfStockText = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004360')}${outOfStockQuantity}`;
                let estimateArrivalOfGoodsTime = v.$uDate.dealTime(params.row.estimateArrivalOfGoodsTime);
                let goodsStatus = params.row.goodsStatus; //货品状态 1.正常 2.停售
                return h('div', [
                  h('p', {class: 'redColor mt5 mb5'}, text),
                  h('p', {class: 'redColor mt5 mb5'}, outOfStockText),
                  goodsStatus === 1 ? h('div', [
                    h('p', {class: 'redColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004361')),
                    h('div', {class: 'flex align-items-center mt5 mb5'}, [
                      h('span', {class: 'redColor'}, estimateArrivalOfGoodsTime),
                      v.getPermission('packageInfo_markOutStock') ? h('Icon', {
                        props: {type: 'md-create', color: '#ff3300'},
                        style: {
                          marginLeft: '5px',
                          fontSize: '17px',
                          cursor: 'pointer',
                          position: 'relative',
                          top: '-2px'
                        },
                        on: {
                          click: () => {
                            v.markOutStockBtn('single', params.row.packageId, 2)
                          }
                        }
                      }) : ''
                    ])
                  ]) : '',
                  goodsStatus === 2 ? h('p', {class: 'redColor mt5 mb5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000084')) : ''
                ])
              }
              if (abnormalStatus === 1) {
                return h('p', {class: 'mt5 mb5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002920'));
              }
            }
            // 待重发
            else if (orderStatus === 3) {
              if (waitingAgainSendJson) {
                let obj = JSON.parse(waitingAgainSendJson);
                let items = {
                  '1': `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004173')}${obj.pickupOrderNumber}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004574')}`,
                  '2': `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004173')}${obj.pickupOrderNumber} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004575')}`,
                }
                let content = items[obj.type];
                return h('div', {class: 'flex align-items-center'}, [
                  h('span', {class: 'redColor'}, text),
                  h('Tooltip', {
                      props: {
                        transfer: true,
                        maxWidth: 250,
                        placement: 'top',
                        content: content
                      },
                      style: {
                        marginLeft: '5px'
                      }
                    },
                    [
                      h('Icon', {
                        props: {
                          type: 'md-help-circle',
                          size: 17
                        },
                        style: {
                          cursor: 'pointer',
                          color: '#ff3300'
                        }
                      })
                    ])
                ])
              }
            } else {
              return h('div', {
                class: orderStatus === 6 ? 'redColor' : ''
              }, text);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003884'),
          key: 'settlementStatus',
          align: 'left',
          minWidth: 140,
          className: 'set_table_td',
          render(h, params) {
            let text = '-';
            let settlementStatus = params.row.settlementStatus;
            v.settlementStatusList.map((item) => {
              if (item.value === settlementStatus) {
                text = item.title;
              }
            })
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          key: 'commodityInfo',
          align: 'left',
          minWidth: 330,
          className: 'set_table_td',
          render(h, params) {
            let supplierSpu = params.row.supplierSpu;
            let ymsSpu = params.row.ymsSpu;
            let imgPath = params.row.imgPath;
            return h('div', {class: 'flex'}, [
              v.tableImg(h, params, null, imgPath),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    linkName: params.row.name,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_1'
                  },
                  on: {
                    AlinkBtn: () => {
                      const {href} = v.$router.resolve({
                        path: '/productDetails',
                        query: {
                          type: 'look',
                          productId: params.row._productInfo.productId
                        }
                      });
                      window.open(href, '_blank');
                    }
                  }
                }),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000600')),
                  h('p', {style: {flex: 1}, class: 'font-weight-bold'}, supplierSpu),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', `${setConfigCharacters(false)}SPU：`),
                  h('p', {style: {flex: 1}}, ymsSpu),
                ])
              ])
            ])
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          minWidth: 250,
          key: 'skuInfo',
          className: 'set_table_td',
          align: 'left',
          render: (h, params) => {
            let list = [];
            let supplierSku = params.row.supplierSku;
            let ymsSku = params.row.ymsSku;
            let isNeedCustomization = params.row.isNeedCustomization;
            let originalYmsSku = params.row.originalYmsSku;
            let productGoodsSpecifications = params.row.productGoodsSpecifications || [];
            if (productGoodsSpecifications.length > 0) {
              list = productGoodsSpecifications.map((item) => {
                return item.value
              });
            }
            return h('div', [
              h('div', {class: 'flex align-items-start mt2 mb2'}, [
                h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004582')),
                h('p', {style: {flex: 1}, class: 'font-weight-bold'}, ymsSku),
              ]),
              h('div', {class: 'flex align-items-start mt2 mb2'}, [
                h('p', 'SKU：'),
                h('p', {style: {flex: 1}}, supplierSku),
              ]),
              h('p', {class: 'mt2 mb2 color-green'}, list.join(' • ')),
              isNeedCustomization === 1 ? h('p', {class: 'flex align-items-center'}, [
                h('span', {class: 'themeColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004552') + originalYmsSku + ')'),
                h('Tooltip', {
                  props: {
                    transfer: true,
                    maxWidth: 450,
                    content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004306'),
                    placement: 'top'
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'md-alert',
                      size: 17
                    },
                    class: 'cursor ml5 themeColor'
                  })
                ])
              ]) : ''
            ])
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001342'),
          key: 'shippingWarehouse',
          minWidth: 130,
          align: 'left',
          className: 'set_table_td',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.warehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001571'),
          key: 'logisticsInfo',
          minWidth: 360,
          align: 'left',
          className: 'set_table_td',
          render(h, params) {
            let {merchantCarrierName, merchantShippingMethodName, trackingNumber, expressageNo, logisticsCarrier, labelPath} = params.row;
            let list = [
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004010') + merchantCarrierName + ' > ' + merchantShippingMethodName + (logisticsCarrier ? '（' + logisticsCarrier + '）' : '')),
              h('p', [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001521') + (trackingNumber || '-')),
                labelPath && labelPath !== '-' ?
                  h('span', {
                    class: 'themeColor ml5 cursor',
                    on: {
                      click: () => {
                        let link = setLinkPath(labelPath);
                        window.open(link, '_blank');
                      }
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004539')) : ''
              ]),
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004530') + (expressageNo || '-'))
            ];
            return h('div', list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003803'),
          key: 'quantity',
          align: 'left',
          className: 'set_table_td',
          minWidth: 140,
          render(h, params) {
            let orderTabType = v.pageParams.orderTabType;
            let orderStatus = params.row.orderStatus;
            let payStatus = params.row.payStatus;
            let quantity = params.row.quantity;
            let actualSortingNumber = [0, 1, 2].includes(orderStatus) || (orderStatus === 1 && payStatus === 1) ?
              '-' : params.row.actualSortingNumber;
            return h('div', {class: 'flex flex-direction'}, [
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004355') + quantity),
              ['0', '4', '5'].includes(orderTabType) ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004583') + actualSortingNumber) : '',
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004167'),
          key: 'actualSortingNumber',
          className: 'set_table_td',
          align: 'left',
          minWidth: 100,
          render(h, params) {
            let talg = false;
            let actualSortingNumber = params.row.actualSortingNumber || '-';
            let doneAssignedNumber = params.row.doneAssignedNumber;
            if (actualSortingNumber > 0 && doneAssignedNumber > 0 && actualSortingNumber !== doneAssignedNumber) {
              talg = true;
            }
            return h('span', {class: talg ? 'redColor' : ''}, actualSortingNumber)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599'),
          key: 'totalPrice',
          align: 'left',
          minWidth: 240,
          className: 'set_table_td',
          renderHeader: (h) => {
            return h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599') + (v.currencyState ? '(' + v.currencyState + ')' : ''));
          },
          render(h, params) {
            let totalPrice = amountHandel(params.row.totalPrice);
            let currency = params.row.totalPriceCurrency || v.currencyState;
            let amountOfGoods = v.expenseProcessingFun(h, params, 1, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004520'));
            let logisticsFee = v.expenseProcessingFun(h, params, 9, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006879'));
            let warehouseProcessingFee = v.expenseProcessingFun(h, params, 16, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006880'));
            return h('div', {class: 'flex flex-direction'}, [
              h('p', {class: 'mt4 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000118') + totalPrice + ' ' + currency),
              // 货品金额
              h('p', {class: 'mt2 mb1'}, [amountOfGoods]),
              // 物流费
              h('p', {class: 'mt2 mb1'}, [logisticsFee]),
              // 仓库处理费
              h('p', {class: 'mt2 mb1'}, [warehouseProcessingFee])
            ])
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004371'),
          key: 'packageStatus',
          align: 'left',
          className: 'set_table_td',
          minWidth: 130,
          render(h, params) {
            let text = '-';
            let outPackageOrderStatus = params.row.outPackageOrderStatus;
            v.deliveryOrderStatusList.map((item) => {
              if (item.value === outPackageOrderStatus) {
                text = item.title;
              }
            })
            return h('span', {
              style: {
                color: outPackageOrderStatus === 6 ? '#FF0000' : ''
              }
            }, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004474'),
          key: 'createdTime',
          align: 'left',
          minWidth: 170,
          className: 'set_table_td',
          render(h, params) {
            return h('span', params.row.createdTime ? v.$uDate.dealTime(params.row.createdTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565'),
          key: 'despatchTime',
          align: 'left',
          minWidth: 170,
          className: 'set_table_td',
          render(h, params) {
            return h('span', params.row.despatchTime ? v.$uDate.dealTime(params.row.despatchTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004585'),
          key: 'ymsPackageStatusTime',
          align: 'left',
          minWidth: 170,
          className: 'set_table_td',
          renderHeader(h, params) {
            return h('div', {class: 'flex align-items-center'}, [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004585')),
              h('Tooltip', {
                props: {
                  offset: 13,
                  transfer: true,
                  maxWidth: 300,
                  content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004586'),
                  placement: 'top-end'
                }
              }, [
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    size: 17
                  },
                  class: 'cursor ml5 themeColor'
                })
              ])
            ]);
          },
          render(h, params) {
            return h('span', params.row.ymsPackageStatusTime ? v.$uDate.dealTime(params.row.ymsPackageStatusTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004462'),
          key: 'requestRehandleTime',
          align: 'left',
          minWidth: 170,
          className: 'set_table_td',
          render(h, params) {
            if (['0', '5'].includes(v.pageParams.orderTabType)) {
              return h('span', params.row.requestRehandleTime ? v.$uDate.dealTime(params.row.requestRehandleTime, 'fulltime') : '-');
            } else {
              return h('span', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004580'),
          key: 'remainingDeliveryTime',
          align: 'left',
          minWidth: 170,
          className: 'set_table_td',
          render(h, params) {
            let remainingDeliveryTime = params.row.remainingDeliveryTime;
            return h('span', remainingDeliveryTime || '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004464'),
          key: 'orderType',
          align: 'left',
          minWidth: 120,
          className: 'set_table_td',
          render(h, params) {
            let text = '-';
            let orderType = params.row.orderType;
            v.orderTypeList.map((item) => {
              if (item.value === orderType) {
                text = item.title;
              }
            })
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006881'),
          key: 'factoryOrderStatus',
          align: 'left',
          minWidth: 140,
          render(h, params) {
            let text = '-';
            let factoryOrderStatus = params.row.factoryOrderStatus;
            v.factoryOrderStatusData.map((item) => {
              if (item.value === factoryOrderStatus) {
                text = item.title;
              }
            })
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006882'),
          key: 'factoryName',
          className: 'set_table_td',
          align: 'left',
          minWidth: 160
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          minWidth: 150,
          key: 'options',
          /*fixed: 'right',*/
          className: 'options_styles_box',
          align: 'left',
          render(h, params) {
            let orderStatus = params.row.orderStatus; // 0 待接单、1 待发货、2 已发货、3 待重发、4 已完成、5 已取消、6 超时未发、7 缺货中
            let payStatus = params.row.payStatus;
            let packageId = params.row.packageId;
            let orderType = params.row.orderType;
            let isOwnShippingMethod = params.row.isOwnShippingMethod;
            let isNeedCustomization = params.row.isNeedCustomization;
            let isProductLabelPath = params.row.isProductLabelPath;
            return h('optsButtonList', {
              props: {
                isShowMoreBtn: false,
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004875'), // 所有状态下均可以打印条码
                    show: (orderType !== 2 || (orderType === 2 && v.isSupportTailCarrierService === 1)) && v.getPermission('packageInfo_appendPackageInfoOrderExpressBill'),
                    clickFn: () => {
                      v.handleOrderBarcode('single', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004587'),
                    show: orderStatus === 7 && payStatus !== 1 && v.getPermission('packageInfo_markOutStock'), // 缺货中
                    clickFn: () => {
                      v.batchMarkingBtn('single', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000526'),
                    color: '#FF0000',
                    show: [1, 3, 6].includes(orderStatus) && payStatus !== 1 && v.getPermission('packageInfo_markOutStock'),  // 待发货、待重发、超时未发
                    clickFn: () => {
                      v.markOutStockBtn('single', params.row.packageId, 1)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004588'),
                    show: orderStatus === 7 && v.getPermission('packageInfo_markOutStock'),
                    clickFn: () => {
                      v.markOutStockBtn('single', params.row.packageId, 2)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006205'),
                    show: ((orderType !== 2 || (orderType === 2 && v.isSupportTailCarrierService === 1)))
                      && orderStatus === 0 && v.getPermission('packageInfo_receivingOrders'),
                    clickFn: () => {
                      v.takingOrdersBtn('single', 1, params.row.packageId)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006883'),
                    show: ((orderType !== 2 || (orderType === 2 && v.isSupportTailCarrierService === 1)))
                      && orderStatus === 0 && v.getPermission('packageInfo_receivingOrders'),
                    clickFn: () => {
                      v.takingOrdersBtn('single', 2, params.row.packageId)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001572'),
                    show: v.getPermission('packageInfo_shipmentDeliveryOrder') && ![2, 4, 5].includes(orderStatus),
                    clickFn: () => {
                      v.bulkShipmentBtn('single', params.row)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004541'),
                    show: isOwnShippingMethod !== 1,
                    clickFn: () => {
                      let labelPath = params.row.labelPath;
                      if (labelPath) {
                        let link = setLinkPath(labelPath);
                        window.open(link);
                      } else {
                        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000617'));
                        return false;
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001525'),
                    show: isNeedCustomization === 1 && orderStatus !== 5,
                    clickFn: () => {
                      v.$refs['viewCustomizedInfo'].initViewCustomizedInfoData(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000323'),
                    show: isProductLabelPath === 1 && v.orderComplianceLabelVerificationTalg,
                    clickFn: () => {
                      let packageInfoOrderGoodsBos = params.row.packageInfoOrderGoodsBos || [];
                      let obj = {
                        ...params.row,
                        ymsPackageGoods: packageInfoOrderGoodsBos
                      }
                      v.$refs['printComplianceLabels'].initPrintComplianceLabelsData(obj);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['dailyRecord'].initDailyRecordData(params.row);
                    }
                  }
                ]
              }
            });
          }
        }
      ],
      selectTableData: [],
      orderStatusList: [],
      deliveryOrderStatusList: [],
      orderTabTypeList: [
        {value: '0', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        // TE-27873  需求调整，去掉的
        /* {
           value: '6',
           title: (h) => {
             return h('div', [
               h('span', '待接单'),
               h('Badge', {
                 props: {
                   count: v.pendingOrdersTotal,
                   overflowCount: 999
                 }
               })
             ])
           }
         },
         {value: '7', title: '待客户付款'},*/
        {
          value: '1',
          title: (h) => {
            return h('div', [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002920')),
              h('Badge', {
                props: {
                  count: v.toBeShippedTotal,
                  overflowCount: 999
                }
              })
            ])
          }
        },
        {value: '2', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327')},
        {value: '4', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003563')},
        {value: '5', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')},
      ],
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006826'), parameterKey: 'packageCodes'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003974'), parameterKey: 'skus'},
        {title: `${setConfigCharacters(false)}SKU`, value: 3, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004499')}`, parameterKey: 'ymsSkus'}
      ],
      defaultSelectValue: 1,
      exportType: '1',
      pendingOrdersTotal: 0,
      toBeShippedTotal: 0,
      printBarcodeList: [
        {name: '1', permissionKey: 'packageInfo_appendYmsSkuExpressBill', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006850')},
        {name: '2', permissionKey: 'packageInfo_appendPackageInfoOrderExpressBill', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006851')},
      ],
      apiUrl: api.put_wmsPickupOrder_printWmsPickupOrder,
      recordParams: {}, // 记录当前筛选条件的参数
      dropDownTimeList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004474'), value: 1, parameterKey: ['createdStartTime', 'createdEndTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565'), value: 2, parameterKey: ['shipedStartTime', 'shipedEndTime']},
      ],
      defaultSelectTimeValue: 1,
      customColumnsKey: 'supplierOrderListColumns',
      setColumnsList: [],
      defaultSelectKeyList: ['packageCode', 'idx', 'options'],
      warehouseList: [],
      orderTypeList: [],
      printUrl: api.post_packageInfo_appendPackageInfoOrderExpressBill,
      printPreviewWaybillTitle: '',
      countrysList: [],
      enumData: []
    }
  },
  computed: {
    filterKeyList() {
      let parameterKeyList = this.dropDownInputList.map((item) => {
        return item.parameterKey
      });
      return parameterKeyList;
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    isSupportTailCarrierService() {
      return this.$store.state.erpConfig.isSupportTailCarrierService || 0;
    },
    // 供应商是否能发尾程
    endJourneyTalg() {
      let talg = false;
      if (this.pageParams.orderType === 2) {
        if (this.isSupportTailCarrierService === 1) {
          talg = true;
        } else {
          talg = false;
        }
      } else {
        talg = true;
      }
      return talg;
    },
    customFieldExportList() {
      let list = [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'packageCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')},
            {paramKey: 'orderStatusStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917')},
            {paramKey: 'name', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000380')},
            {paramKey: 'sku', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586')},
            {paramKey: 'quantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003656')},
            {paramKey: 'variations', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000721')},
            {paramKey: 'outOrderStatusStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004371')},
            {paramKey: 'totalPriceStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599')},
            {paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004474')},
            {paramKey: 'requestRehandleTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004462')},
            {paramKey: 'despatchTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565')},
            {paramKey: 'ymsPackageStatusTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004585')},
            {paramKey: 'orderType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004464')},
            {paramKey: 'processingStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006881')},
            {paramKey: 'factoryName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006882')},
            {paramKey: 'buyerName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006884')},
            {paramKey: 'buyerPhone', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002852')},
            {paramKey: 'buyerMobile', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002812')},
            {paramKey: 'buyerCountryStateCity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006885')},
            {paramKey: 'buyerAddress', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002859')},
            {paramKey: 'buyerPostalCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002340')},
            {paramKey: 'deliverWarehouseName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001342')},
            {paramKey: 'merchantShippingMethodName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000222')},
            {paramKey: 'trackingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698')},
            {paramKey: 'expressageNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006329')},

            {paramKey: 'totalPackageGoodsPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006886')},
            {paramKey: 'logisticsCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005874')},
            {paramKey: 'warehouseHandlePrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001213')},
          ]
        }
      ];
      let keyList = ['processingStatus', 'factoryName'];
      if (!this.merchantConfigurationFactory) {
        list.forEach(item => {
          item.checkBoxList = item.checkBoxList.filter(item => !keyList.includes(item.paramKey));
        });
      }
      return list;
    },
    originalColumnsData() {
      if (!this.merchantConfigurationFactory) {
        let keyList = ['factoryOrderStatus', 'factoryName'];
        return this.originalColumns.filter((item) => {
          return !keyList.includes(item.key)
        })
      } else {
        return this.originalColumns
      }
    },
    // pod配置
    merchantConfigurationFactory() {
      const obj = commonLocalStorage.getItem('supplierConfigurationItemInfo') ?? this.$store.state.supplierConfigurationItemInfo;
      return obj?.productGoodsFactory === 'Y';
    },
    // 商品加工状态
    factoryOrderStatusData() {
      const ENUM_KEY = 'PackageInfoProcessingStatusSupplierEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    // 订单状态
    orderStatusData() {
      const ENUM_KEY = 'PackageInfoOrderStatusSupplierEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    // 出库状态
    outboundStatusList() {
      const ENUM_KEY = 'PackageInfoPackageProcessStatusSupplierEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    // 结算状态
    settlementStatusList() {
      const ENUM_KEY = 'PackageInfoPackageSettlementStatusSupplierEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    // 订单合规标签校验配置项是否开启
    orderComplianceLabelVerificationTalg() {
      const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 1;
    },
  },
  created() {
    let v = this;
    if (['0', '4', '5'].includes(v.pageParams.orderTabType)) {
      v.setDefaultTimerParams('three_months', 1);
    }
    if (v.merchantConfigurationFactory) {
      v.pageParams.orderType = 'null';
    } else {
      v.pageParams.orderType = 1;
    }
    // 获取消息中心跳转过来的参数
    let packageCode = localStorage.getItem('supplierOrderListQuery') ? JSON.parse(localStorage.getItem('supplierOrderListQuery')) : null;
    if (packageCode) {
      v.$nextTick(() => {
        v.pageParams.orderTabType = '0';
        v.defaultSelectValue = 1;
        v.$refs.dropDownFilter.inputValue = packageCode;
        v.pageParams.packageCodes = packageCode;
        v.initFun();
      });
      setTimeout(() => {
        localStorage.removeItem('supplierOrderListQuery');
        v.$store.commit('updateSystemMenu', false);
      }, 2000);
    } else {
      v.initFun();
    }
  },
  methods: {
    // 初始化接口数据
    initFun() {
      this.warehouseList = [];
      (async () => {
        let enumKeyList = [
          'PackageGoodsOrderTypeSupplierEnum',
          'PackageInfoProcessingStatusSupplierEnum',
          'PackageInfoOrderStatusSupplierEnum',
          'PackageInfoPackageProcessStatusSupplierEnum',
          'PackageInfoPackageSettlementStatusSupplierEnum'
        ];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await this.handleStatusData(this.pageParams.orderTabType);
        await this.handleOrderTypeList();
        await getAllCountrysData('cn', true).then((data) => {
          this.countrysList = data;
        });
        await this.getPendingProcessingNum();
        await this.search();
      })();
    },
    // 处理订单类型
    async handleOrderTypeList() {
      const ENUM_KEY = 'PackageGoodsOrderTypeSupplierEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      if (!this.merchantConfigurationFactory) {
        list = list.filter(item => ![2].includes(item.value));
      }
      list.unshift({
        value: null,
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      list.forEach((item, index) => {
        item.selected = index === 0;
      });
      this.orderTypeList = list;
    },
    // 重置数据
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.changeInput(1);
      v.selectTableData = [];
      v.changeTimeInput(1);
      if (['0', '4', '5'].includes(v.pageParams.orderTabType)) {
        v.setDefaultTimerParams('three_months', 1);
      }
      v.orderTypeBtn(0, null);
      v.getList();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.selectTableData = [];
      v.total = 0;
      v.tableData = [];
      v.handleColumns();
      v.getPendingProcessingNum();
      if (v.getPermission('packageInfo_queryDeliveryPackageInfoOrder')) {
        v.tableLoading = true;
        v.axios.post(api.post_packageInfo_queryDeliveryPackageInfoOrder, v.handleParameter()).then(response => {
          v.recordParams = v.handleParameter();
          if (response.data.code === 0) {
            let data = response.data.datas;
            let list = data.list || [];
            v.total = data.total;
            if (list.length > 0) {
              v.handleTableData(list);
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 处理列表数据
    handleTableData(data) {
      let v = this;
      v.warehouseList = [];
      let warehouseData = [];
      let productGoodsIds = [];
      let warehouseIds = [];
      let handleList = [];
      let newData = [];
      data.map((item) => {
        if (item.warehouseId) {
          warehouseIds.push(item.warehouseId)
        }
        let packageInfoOrderGoods = item.packageInfoOrderGoodsBos || [];
        if (packageInfoOrderGoods.length > 0) {
          packageInfoOrderGoods.map((ele, index) => {
            ele.packageCode = item.packageCode;
            ele.ymsWarehouseId = item.ymsWarehouseId;
            newData.push(Object.assign({}, item, ele));
          });
        } else {
          newData.push(item);
        }
      });
      if (newData.length > 0) {
        newData.map((item, index) => {
          if (item.productGoodsId) {
            productGoodsIds.push(item.productGoodsId)
          }
        });
        productGoodsIds = v.uniqueFunc(productGoodsIds);
        warehouseIds = v.uniqueFunc(warehouseIds);
        (async () => {
          if (warehouseIds.length > 0) {
            warehouseData = await getAllWarehouseData({warehouseIds});
            v.warehouseList = warehouseData.filter(item => item.servicePlatform === 'supplier');
            newData.forEach(item => {
              const found = v.countrysList.find(ele => ele.twoCode === item.buyerCountryCode);
              item.countryCodeName = found ? found.cnName : '-'
            });
          }
          if (productGoodsIds.length > 0) {
            handleList = await v.getProductInfoByIds(productGoodsIds, newData, false, false, false,
              api.post_productInfo_queryByProductGoodsIds, 'supplier');
            if (handleList.length > 0) {
              handleList.map((item) => {
                item.supplierSku = item.sku;
                item.ymsSku = item._productInfo ? item._productInfo.ymsSku : null;
                item.supplierSpu = item._productInfo ? item._productInfo._spuInfo ? item._productInfo._spuInfo.spu : null : null;
                item.ymsSpu = item._productInfo ? item._productInfo._spuInfo ? item._productInfo._spuInfo.ymsSpu : null : null;
                item.productGoodsSpecifications = item._productInfo ? item._productInfo.productGoodsSpecifications : []
              });
              v.tableData = [];
              // 处理分组
              let packageCodeMap = new Map();
              handleList.forEach((item) => {
                let {packageCode, ymsSpu, ymsSku, supplierSpu, supplierSku, productGoodsSpecifications, ...obj} = item;
                let productId = item._productInfo.productId;
                let name = item._productInfo._spuInfo.name;
                let skuImgPath = item._productInfo.primaryImage || '';
                let spuImgPath = item._productInfo._spuInfo.primaryImage || '';
                let imgPath = skuImgPath ? skuImgPath : spuImgPath;

                let packageInfoOrderGoodsBos = item.packageInfoOrderGoodsBos || [];
                // 初始化 packageCode 数据
                if (!packageCodeMap.has(packageCode)) {
                  packageCodeMap.set(packageCode, {packageCode, ...obj, spuList: []});
                }
                let spuList = packageCodeMap.get(packageCode).spuList;
                // 初始化 supplierSpu 数据
                if (!spuList.some((spuItem) => spuItem.supplierSpu === supplierSpu)) {
                  spuList.push({
                    supplierSpu,
                    ymsSpu,
                    productId,
                    name,
                    imgPath,
                    skuList: []
                  });
                }
                let skuList = spuList.find((spuItem) => spuItem.supplierSpu === supplierSpu).skuList;
                // 添加 sku 数据
                let skuObj = {};
                let arr = packageInfoOrderGoodsBos.filter((ele) => {
                  return ele.sku === supplierSku
                });
                if (arr.length > 0) {
                  skuObj = arr[0]
                }
                skuObj = Object.assign({}, skuObj, {supplierSku: supplierSku, ymsSku: ymsSku, productGoodsSpecifications})
                skuList.push(skuObj);
              });
              // 将 Map 转为数组
              let packageCodeList = Array.from(packageCodeMap.values());

              // 处理合并数据
              function handleMergeData(mergeData) {
                let newList = [];
                mergeData.map((item, idx) => {
                  item.spuList.map((ele) => {
                    ele.skuList.map((talg) => {
                      newList.push({
                        ...item,
                        ...talg,
                        supplierSpu: ele.supplierSpu,
                        ymsSpu: ele.ymsSpu,
                        name: ele.name,
                        imgPath: ele.imgPath
                      })
                    })
                  })
                });
                return newList;
              }

              // 按照ymsSku升序排列
              let list = handleMergeData(packageCodeList);
              const packageCodes = [...new Set(list.map(item => item.packageCode))];
              packageCodes.forEach(code => {
                const itemsWithSameCode = list.filter(item => item.packageCode === code);
                itemsWithSameCode.sort((a, b) => a.ymsSku.localeCompare(b.ymsSku));

                const index = list.findIndex(item => item.packageCode === code);
                list.splice(index, itemsWithSameCode.length, ...itemsWithSameCode);
              });

              v.tableData = list;
              v.updateTableDom('tableDom');
            }
          } else {
            v.tableData = data;
            v.tableLoading = false;
            v.updateTableDom('tableDom');
          }
        })();
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let v = this;
      let columnList = [];
      let columnSpuList = [];
      let handleKeyList = ['commodityInfo', 'skuInfo', 'quantity', 'actualSortingNumber', 'orderStatus', 'orderType', 'factoryOrderStatus'];
      let handleSpuKeyList = ['commodityInfo'];

      // 获取列的索引
      if (v.tableColumns.length > 0) {
        v.tableColumns.forEach((item, index) => {
          if (!handleKeyList.includes(item.key)) {
            columnList.push(index);
          }
          if (handleSpuKeyList.includes(item.key)) {
            columnSpuList.push(index);
          }
        });
      }
      // 订单维度合并
      if (columnList.includes(columnIndex)) {
        const colSpan = {rowspan: 1, colspan: 1};
        if (rowIndex > 0 && row.packageCode === v.tableData[rowIndex - 1].packageCode) {
          colSpan.rowspan = 0;
        } else {
          for (let i = rowIndex + 1; i < v.tableData.length; i++) {
            if (v.tableData[i].packageCode === row.packageCode) {
              colSpan.rowspan++;
            } else {
              break;
            }
          }
        }
        return colSpan;
      }
      // spu维度合并
      if (columnSpuList.includes(columnIndex)) {
        const colSpanSpu = {rowspan: 1, colspan: 1};
        const supplierSpu = row.supplierSpu;
        const prevRow = v.tableData[rowIndex - 1] || null;
        const prevSupplierSpu = prevRow ? prevRow.supplierSpu : null;
        const prevPackageCode = prevRow ? prevRow.packageCode : null;
        if (prevPackageCode === row.packageCode && prevSupplierSpu === supplierSpu) {
          colSpanSpu.rowspan = 0;
        } else {
          for (let i = rowIndex + 1; i < v.tableData.length; i++) {
            if (v.tableData[i].packageCode === row.packageCode) {
              const currentSupplierSpu = v.tableData[i].supplierSpu;
              if (currentSupplierSpu === supplierSpu) {
                colSpanSpu.rowspan++;
              } else {
                break;
              }
            } else {
              break;
            }
          }
        }
        return colSpanSpu;
      }
    },

    // 获取选中的时间
    selectTime(data) {
      let v = this;
      let time = data.date;
      let timeList = v.defaultTimePeriod(time);
      let current = data.value;
      v.dropDownTimeList.map((item) => {
        if (item.value === current) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          v.$nextTick(() => {
            v.$refs['dropDownDateTime'].timeList = v.defaultTimePeriod(time, false);
          });
          v.pageParams[startTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams[endTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
          v.$forceUpdate();
        }
      });
    },
    // 改变默认时间筛选下拉选项的值
    changeTimeInput(value) {
      this.defaultSelectTimeValue = value;
      this.$refs['dropDownDateTime'].timeList = [];
      this.dropDownTimeList.map((item) => {
        let startTimeKey = item.parameterKey[0];
        let endTimeKey = item.parameterKey[1];
        this.pageParams[startTimeKey] = null;
        this.pageParams[endTimeKey] = null;
      });
    },
    // 重置选中的时间
    resetTime(value) {
      this.dropDownTimeList.map((item) => {
        if (item.value === value) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          this.pageParams[startTimeKey] = null;
          this.pageParams[endTimeKey] = null;
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data;
      }
    },
    // 批量发货
    bulkShipmentBtn(type, obj) {
      let v = this;
      let talg = true;
      if (type === 'all') {
        if (v.selectTableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006852'));
          talg = false;
        }
        if (handleData(v.selectTableData)) {
          if (v.selectTableData.length > 1) {
            const firstYmsId = v.selectTableData[0].ymsWarehouseId;
            const firstWarehouseId = v.selectTableData[0].warehouseId;
            const allYmsIdSame = v.selectTableData.every(item => item.ymsWarehouseId === firstYmsId);
            const allWarehouseIdSame = v.selectTableData.every(item => item.warehouseId === firstWarehouseId);
            talg = v.selectTableData.every(item => item.deliveryType === 2 && item.isOwnShippingMethod !== 1);
            if ((allYmsIdSame && allWarehouseIdSame) && talg) {
              let packageIds = v.selectTableData.map((item) => {
                return item.packageId
              });
              let query = {
                packageIds: packageIds
              };
              markShipmentFun(query);
            } else {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006887'));
            }
          } else {
            singleFun(v.selectTableData[0]);
          }
        }
      } else {
        singleFun(obj);
      }

      // 单个操作
      function singleFun(obj) {
        if (handleData([obj])) {
          let {isOwnShippingMethod, deliveryType, expressageCode, expressageNo, carrierId, shippingMethodId, trackingNumber, packageId} = obj;
          if (isOwnShippingMethod === 1) {
            v.$refs['markShipment'].initMarkShipmentData('supplierLogistics', obj);
          } else {
            if (deliveryType === 1) {
              v.$refs['markShipment'].initMarkShipmentData('thirdPartyLogistics', obj);
            } else {
              let query = {
                carrierId: carrierId,
                deliveryType: deliveryType,
                expressageCode: expressageCode,
                expressageNo: expressageNo,
                isOwnCarrier: isOwnShippingMethod,
                packageIds: [packageId],
                shippingMethodId: shippingMethodId,
                trackingNumber: trackingNumber
              };
              markShipmentFun(query);
            }
          }
        }
      }

      // 校验
      function handleData(selectTableData) {
        // 出库单状态：待发货  订单状态：非缺货，满足这两个条件的时候才可以操作执行发货
        let orderStatusTalg = selectTableData.every((item) => {
          return item.orderStatus !== 7
        });
        if (!orderStatusTalg) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006888'));
          talg = false;
        } else {
          let outPackageOrderStatusTalg = selectTableData.every((item) => {
            return item.outPackageOrderStatus === 1
          })
          if (!outPackageOrderStatusTalg) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006889'));
            talg = false;
          }
        }
        return talg;
      }

      // 标记发货
      function markShipmentFun(query) {
        v.axios.post(api.post_packageInfo_shipmentDeliveryOrder, query,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006890'));
            v.pageParamsStatus = true;
          }
        });
      }
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.orderTabType = Number(v.pageParams.orderTabType);
      if (!v.merchantConfigurationFactory) {
        params.orderType = 1;
      }
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      let keyList = ['orderType'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : v.pageParams[key];
      }
      return params;
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.packageIds = v.selectTableData.map((item) => {
          return item.packageId;
        });
      } else {
        query.packageIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          v.axios.post(api.post_packageInfo_exportPackageInfoOrder, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/supplier.html#/exportTask?operateCode=' + taskNumber, '/yms-supplier-service', '_blank');
              }, 30)
            }
          });
        }
      });
    },
    // 批量标记到货
    batchMarkingBtn(type, data) {
      let v = this;
      let talg = true;
      if (type === 'single') {
        talg = true;
      } else {
        if (v.tableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006891'));
          talg = false;
        }
        if (v.selectTableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006892'));
          talg = false;
        }
      }
      if (talg) {
        let arrivalTalg = false;
        let newList = [];
        if (data) {
          arrivalTalg = data.orderStatus === 7;
        } else {
          newList = v.selectTableData.filter((item) => {
            return item.orderStatus === 7;
          });
          arrivalTalg = newList.length > 0;
        }
        if (arrivalTalg) {
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006893'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006894'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004587'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
            onOk: () => {
              let query = [];
              if (type === 'single') {
                let packageInfoOrderGoodsBos = data.packageInfoOrderGoodsBos || [];
                if (packageInfoOrderGoodsBos.length > 0) {
                  packageInfoOrderGoodsBos.map((item) => {
                    query.push({
                      estimateArrivalOfGoodsTime: null,
                      markType: 3, // 标记类型 1.补货 2.停售 3.到货
                      operationType: 3, // 操作类型 1.标记缺货 2.更新标记 3.标记到货
                      outOfStockQuantity: null,
                      packageCodes: [data.packageCode],
                      productGoodsId: item.productGoodsId
                    })
                  })
                }
              } else {
                let packageInfoOrderGoodsBosList = [];
                v.selectTableData.map((item) => {
                  packageInfoOrderGoodsBosList.push(...item.packageInfoOrderGoodsBos)
                });
                if (packageInfoOrderGoodsBosList.length > 0) {
                  packageInfoOrderGoodsBosList.map((item) => {
                    query.push({
                      estimateArrivalOfGoodsTime: null,
                      markType: 3, // 标记类型 1.补货 2.停售 3.到货
                      operationType: 3, // 操作类型 1.标记缺货 2.更新标记 3.标记到货
                      outOfStockQuantity: null,
                      packageCodes: [item.packageCode],
                      productGoodsId: item.productGoodsId
                    })
                  })
                }
              }
              v.axios.post(api.post_packageInfo_markOutStock, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
                if (res.data.code === 0) {
                  v.$refs['tableDom'].selectAll(false);
                  v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000530'));
                  v.pageParamsStatus = true;
                }
              });
            }
          });
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006895'));
          return false;
        }
      }
    },
    // 打印YMS条码
    printBarcodeBtn(value) {
      let v = this;
      let talg = true;
      if (value === '1') {
        this.$refs['scanOrderChange'].scanOrderChangeModal = true;
        this.$refs['scanOrderChange'].scanOrderType = 'supplierOrderList';
      } else {
        if (v.selectTableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006858'));
          talg = false;
        }
        if (v.tableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006859'));
          talg = false;
        }
        if (talg) {
          v.handleOrderBarcode('all');
        }
      }
    },
    // 批量打印订单条码
    handleOrderBarcode(type, row) {
      let v = this;
      let obj = null;
      let list = [];
      if (type === 'all') {
        obj = v.selectTableData[0];
        list = v.selectTableData;
        v.printPreviewWaybillTitle = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006851')}`;
      } else {
        obj = row;
        list = [row];
        v.printPreviewWaybillTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004875');
      }
      v.batchPrinting = true;
      v.$refs['printPreviewWaybill'].initPrintPreviewWaybillData(obj, list);
    },
    // 更新
    updatePrint() {
      this.updateSelect();
    },
    // 打印配货清单
    printDistributionBtn() {
      let talg = this.tableData.length > 0 && this.selectTableData.length > 0;
      if (talg) {
        this.$refs['distributionListFormat'].initDistributionListFormat(this.selectTableData, 'supplierOrderList');
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006857'));
        return false;
      }
    },
    // 重置勾选数据的状态
    updateSelect() {
      this.$refs['tableDom'].selectAll(false);
      this.selectTableData = [];
    },
    // 处理列表字段
    handleColumns(data) {
      let v = this;
      // 0全部  1:待发货 2:已发货 4:已完成 5:已取消 6待接单 7待客户付款
      let hideKeyColumns = [];
      let obj = {
        '1': ['settlementStatus', 'despatchTime', 'ymsPackageStatusTime', 'actualSortingNumber'],
        '2': ['settlementStatus', 'ymsPackageStatusTime', 'remainingDeliveryTime', 'actualSortingNumber'],
        '4': ['remainingDeliveryTime'],
        '5': ['settlementStatus', 'remainingDeliveryTime', 'actualSortingNumber'],
        '6': ['actualSortingNumber'],
        '7': ['actualSortingNumber'],
      }
      hideKeyColumns = obj[v.pageParams.orderTabType] || [];
      if (!v.merchantConfigurationFactory) {
        hideKeyColumns = [...hideKeyColumns, 'factoryOrderStatus', 'factoryName'];
      }
      let sortKeyList = data || v.setColumnsList;
      let list = v.handleCustomColumnsSort(sortKeyList, hideKeyColumns, v.originalColumns, v.defaultSelectKeyList);
      if (list.length > 0) {
        v.tableColumns = list;
      } else {
        v.tableColumns = v.originalColumns.filter((item) => {
          return !hideKeyColumns.includes(item.key)
        });
      }
      v.updateTableDom('tableDom');
    },

    // 切换Tab
    changeTab(name) {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.changeInput(1);
      v.changeTimeInput(1);
      v.selectTableData = [];
      v.pageParams.orderTabType = name;
      if (['0', '4', '5'].includes(v.pageParams.orderTabType)) {
        v.$nextTick(() => {
          v.setDefaultTimerParams('three_months', 1);
        });
      }
      v.search();
    },
    // 获取当前列表设置展示的字段
    customColumnsData(data) {
      this.setColumnsList = data;
      this.handleColumns(data);
    },
    // 标记缺货
    markOutStockBtn(type, packageId, val) {
      let v = this;
      let packageIdList = [];
      if (type === 'single') {
        packageIdList = [packageId]
      } else {
        if (v.selectTableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006892'));
          return false;
        } else {
          let talg = v.selectTableData.some((item) => {
            return item.orderStatus == 7
          });
          if (talg) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006896'));
            return false;
          } else {
            v.selectTableData.map((item) => {
              packageIdList.push(item.packageId)
            })
          }
        }
      }
      if (packageIdList.length > 0) {
        v.axios.post(api.post_packageInfo_queryOvertimeUnsentList, packageIdList).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              let newData = data.slice(0, 100);
              v.$refs['overtimeOrderProcess'].initOvertimeOrderProcessingData('mark', newData, val)
            } else {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004600'));
              return false;
            }
          }
        });
      }
    },
    // 处理状态数据
    async handleStatusData(value) {
      // 出库状态
      this.deliveryOrderStatusList = [];
      let values = {
        '0': [1, 2, 3, 4, 5, 6, 7, 8],
        '1': [1, 2, 3, 6],
        '2': [4, 8],
        '4': [4, 5],
        '5': [7]
      }
      if (values[value]) {
        this.outboundStatusList.map((item) => {
          if (values[value].includes(item.value)) {
            this.deliveryOrderStatusList.push(item);
          }
        })
      }
      // 订单状态
      this.orderStatusList = [];
      let orderValues = {
        '0': [0, 1, 2, 3, 4, 5, 6, 7],
        '1': [1, 6, 7, 3]
      }
      if (orderValues[value]) {
        this.orderStatusData.map((item) => {
          if (orderValues[value].includes(item.value)) {
            this.orderStatusList.push(item);
          }
        })
      }
    },
    // 获取待处理的数量
    getPendingProcessingNum() {
      let v = this;
      let orderTabType = JSON.parse(JSON.stringify(v.pageParams.orderTabType));
      v.axios.get(api.get_packageInfo_queryPackageInfoOrderTabTotal + '?isSupplierSupportDirectDelivery=1').then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.$store.commit('updatePendingCount', Date.now());
            v.pendingOrdersTotal = data.pendingOrderTotal || 0;
            v.toBeShippedTotal = data.toBeShippedTotal || 0;
            v.$nextTick(() => {
              v.pageParams.orderTabType = orderTabType;
            })
          } else {
            v.pendingOrdersTotal = 0;
            v.toBeShippedTotal = 0;
          }
        }
      });
    },
    // 接单、拒绝
    takingOrdersBtn(type, val, packageId) {
      let v = this;
      let talg = true;
      let query = {
        isOrderTaking: val, // 1:接单 2:拒绝接单
        packageIds: []
      }
      if (type === 'all') {
        if (v.tableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006853'));
          talg = false;
        } else {
          if (v.selectTableData.length <= 0) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006852'));
            talg = false;
          } else {
            query.packageIds = this.selectTableData.map((item) => {
              return item.packageId
            });
          }
        }
      } else {
        query.packageIds = [packageId];
      }
      if (talg) {
        let title = val === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006897') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006898');
        let content = val === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006899') :
          aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006900');
        let okText = val === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006253') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006901');
        let text = val === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006902') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006903');
        v.$Modal.confirm({
          title: title,
          content: content,
          okText: okText,
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.axios.put(api.put_packageInfo_receivingOrders, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(text);
                v.pageParamsStatus = true;
              }
            });
          },
          onCancel: () => {
          }
        });
      }
    },
    // 选取订单类型
    orderTypeBtn(index, value) {
      let v = this;
      v.pageParams.orderType = value;
      v.orderTypeList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    // 监听tab栏切换
    'pageParams.orderTabType': {
      handler(value) {
        this.handleStatusData(value)
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    printPreviewWaybillModal,
    viewCustomizedInfoModal,
    dropDownFilter,
    exportFieldsModal,
    distributionListFormatModal,
    dailyRecordModal,
    scanOrderChangeModal,
    printCaseMarkModal,
    dropDownDateTime,
    customColumnsDrawer,
    overtimeOrderProcessingModal,
    markShipmentModal,
    printComplianceLabelsModal
  }
}
</script>

<style lang="less" scoped>
/deep/ .table_box {
  .selection_styles_box {
    position: sticky !important;
    left: 0;
    z-index: 5;
    overflow: initial !important;

    &:after {
      right: -2px;
      top: 0;
      content: ' ';
      width: 2px;
      height: 100%;
      background: #e8eaec;
      position: absolute;
      z-index: 100;
    }

    &:before {
      content: ' ';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #e8eaec;
    }
  }

  td.options_styles_box {
    position: sticky !important;
    right: 0px;
    z-index: 5;
    overflow: initial !important;

    &:before {
      left: -2px;
      top: 0;
      content: ' ';
      width: 2px;
      height: 100%;
      background: #e8eaec;
      position: absolute;
      z-index: 100;
    }

    &:after {
      right: -1px;
      top: 0;
      content: ' ';
      width: 2px;
      height: 100%;
      background: #fff;
      position: absolute;
      z-index: 100;
    }

    .ivu-table-cell {
      padding-top: 8px;
      display: flex;
      align-items: flex-start;
      height: 100%;
      position: relative;

      &:after {
        content: ' ';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #e8eaec;
      }
    }
  }

  th.options_styles_box {
    position: sticky !important;
    right: 0px;
    z-index: 5;
    overflow: initial !important;

    &:before {
      left: -2px;
      top: 0;
      content: ' ';
      width: 2px;
      height: 100%;
      background: #e8eaec;
      position: absolute;
      z-index: 100;
    }
  }

  th.options_styles_box:nth-last-child(2) {
    position: sticky !important;
    right: 12px;
    z-index: 5;
    overflow: initial !important;

    &:before {
      left: -2px;
      top: 0;
      content: ' ';
      width: 2px;
      height: 100%;
      background: #e8eaec;
      position: absolute;
      z-index: 100;
    }

    &:after {
      right: -12px;
      top: 0;
      content: ' ';
      width: 14px;
      height: 100%;
      background: #F8F8F9;
      position: absolute;
      z-index: 100;
    }
  }
}

</style>
